import report from '@/api/report/report'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
    ...baseState,
    formViewDatas: [],
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
}

export const actions = {
    // generate candidate profile list
    candidateProfileList(context, attributes = {}) {
        return report.candidateProfileList({ params: attributes })
    },
    // generate exam registration list
    examRegistrationList(context, attributes = {}) {
        return report.examRegistrationList({ params: attributes })
    },
    // generate exam registration list
    examEvaluationList(context, attributes = {}) {
        return report.examEvaluationList({ params: attributes })
    },
    // generate exam registration detail
    examEvaluationDetail(context, attributes = {}) {
        return report.examEvaluationDetail({ params: attributes })
    },
    // generate print operation List
    printOperationList(context, attributes = {}) {
        return report.printOperationList({ params: attributes })
    },
    async getFormViewData(context, { params, index }) {
        let response = await report.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
}
